

const navMenu=[
    {
        title:'home',
        url:"/",
    },
    {
        title:"about",
        url:"/about",
    },
    {
        title:"faqs",
        url:"/faqs",
    },
    {
        title:"contact",
        url:"/contact",
    },
]

export default navMenu